export const MESSAGES_DETAIL_RESET = 'MESSAGES_DETAIL_RESET';

export const MESSAGES_DETAIL_GET_START = 'MESSAGES_DETAIL_GET_START';
export const MESSAGES_DETAIL_GET_SUCCESS = 'MESSAGES_DETAIL_GET_SUCCESS';
export const MESSAGES_DETAIL_GET_FAILURE = 'MESSAGES_DETAIL_GET_FAILURE';

export const MESSAGES_ATTACHMENT_GET_REQUEST = 'MESSAGES_ATTACHMENT_GET_REQUEST';

export const MESSAGES_SET_READ_REQUEST = 'MESSAGES_SET_READ_SET_REQUEST';
export const MESSAGES_SET_READ_SUCCESS = 'MESSAGES_SET_READ_SUCCESS';
export const MESSAGES_SET_READ_FAILURE = 'MESSAGES_SET_READ_FAILURE';

export const MESSAGES_SET_ARCHIVED_REQUEST = 'MESSAGES_SET_ARCHIVED_REQUEST';
export const MESSAGES_SET_ARCHIVED_SUCCESS = 'MESSAGES_SET_ARCHIVED_SUCCESS';
export const MESSAGES_SET_ARCHIVED_FAILURE = 'MESSAGES_SET_ARCHIVED_FAILURE';

export const MESSAGES_ADD_PARTICIPANTS_REQUEST = 'MESSAGES_ADD_PARTICIPANTS_REQUEST';
export const MESSAGES_ADD_PARTICIPANTS_SUCCESS = 'MESSAGES_ADD_PARTICIPANTS_SUCCESS';
export const MESSAGES_ADD_PARTICIPANTS_FAILURE = 'MESSAGES_ADD_PARTICIPANTS_FAILURE';

export const MESSAGES_CREATE_REQUEST = 'MESSAGES_CREATE_REQUEST';
